import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { useEffect } from 'react';

const Conversations = () => {
  useEffect(() => {
    document.title = 'Episodes | The Second Seat';
    window.scrollTo(0, 0);
  }, []);

  const episodes = [
    {
      number: '04',
      title: 'A Working Position — Raja Bundela',
      subtitle: 'The character actor\u2019s Lakshman Rekha, and the room he changed from its edge. Three parts, plus behind the scenes.',
      role: 'NSD 1977 \u00b7 Director \u00b7 Bundelkhand Statehood \u00b7 Khajuraho International Film Festival',
      thumbnails: [
        { src: 'https://img.youtube.com/vi/fGEstdw3fDo/maxresdefault.jpg', partNum: null, partLabel: null, url: 'https://youtu.be/fGEstdw3fDo?si=plfryahiB_gsmh6X' },
        { src: 'https://img.youtube.com/vi/J0ar9aAxzqI/maxresdefault.jpg', partNum: null, partLabel: null, url: 'https://youtu.be/J0ar9aAxzqI?si=AxgRTNB4u9MtiFR6' },
        { src: 'https://img.youtube.com/vi/EEfOpPiK44g/maxresdefault.jpg', partNum: null, partLabel: null, url: 'https://youtu.be/EEfOpPiK44g' }
      ],
      researchLink: '/episodes/episode-04'
    },
    {
      number: '03',
      title: 'Mere Focus Ki Love Story — Venkat Alexa',
      subtitle: 'Twenty-two years of focus, eight hundred commercials, one new producer. Two parts.',
      role: 'Focus Puller \u00b7 ARRI Alexa specialist \u00b7 Producer \u00b7 FEFSI member, twenty-four crafts',
      thumbnails: [
        { src: 'https://img.youtube.com/vi/JjwW9WCboGU/maxresdefault.jpg', partNum: 'Part 1', partLabel: 'The Focus Puller', url: 'https://youtu.be/JjwW9WCboGU?si=4ts2ZYbJGV1avyvF' },
        { src: 'https://img.youtube.com/vi/CqNrs0kQhJc/maxresdefault.jpg', partNum: 'Part 2', partLabel: 'The Producer', url: 'https://youtu.be/CqNrs0kQhJc?si=v4DWMZlb01hr0fyZ' }
      ],
      researchLink: '/episodes/episode-03'
    },
    {
      number: '02',
      title: 'Ramanuj, Before Anuj — Anuj Sharma',
      subtitle: 'Chhattisgarh, cinema, and the seat beside him. Two parts.',
      role: 'Padma Shri \u00b7 Actor \u00b7 UNICEF Celebrity Advocate \u00b7 Singer \u00b7 MLA, Dharsiwa',
      thumbnails: [
        { src: 'https://img.youtube.com/vi/8-B1hmXt-Ss/maxresdefault.jpg', partNum: 'Part 1', partLabel: '\u091C\u0928\u092A\u094D\u0930\u0924\u093F\u0928\u093F\u0927\u093F', url: 'https://youtu.be/8-B1hmXt-Ss?si=dgV8Qq6jTNbfXU_r' },
        { src: 'https://img.youtube.com/vi/dpJ3KO-T3Yw/maxresdefault.jpg', partNum: 'Part 2', partLabel: '\u0905\u092A\u0928\u093E \u0906\u0926\u092E\u0940', url: 'https://youtu.be/dpJ3KO-T3Yw?si=lVoJRIHiGJclfaAk' }
      ],
      researchLink: '/episodes/episode-02'
    },
    {
      number: '01',
      title: '"I Love Lights" — C. Raja Krishnan',
      subtitle: 'Rajinikanth, Dharavi, and French cinema. 27 years.',
      role: 'Gaffer',
      thumbnails: [
        { src: 'https://img.youtube.com/vi/0EEX0qmVU8c/maxresdefault.jpg', partNum: 'Watch', partLabel: null, url: 'https://youtu.be/0EEX0qmVU8c?si=H6Yk6s2x3mzrGsvs' }
      ],
      researchLink: '/episodes/episode-01'
    }
  ];

  return (
    <div className="min-h-screen overflow-x-hidden" style={{ background: '#000000' }}>
      {/* Header */}
      <nav className="py-4 px-6 sm:px-8 flex items-center justify-between" style={{ borderBottom: '1px solid rgba(240,235,224,0.06)' }}>
        <Link to="/" className="text-base sm:text-lg italic opacity-70 hover:opacity-100 transition-opacity" style={{ fontFamily: 'EB Garamond, serif', color: '#f0ebe0' }}>
          The Second Seat
        </Link>
        <div className="flex gap-4 sm:gap-6 items-center">
          <Link to="/writing" className="font-mono text-[11px] sm:text-xs tracking-[0.15em] uppercase opacity-65 hover:opacity-100 transition-opacity" style={{ color: '#f0ebe0' }}>
            Film Analysis
          </Link>
        </div>
      </nav>

      <div className="max-w-4xl mx-auto px-6 sm:px-8 py-16 sm:py-24">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-center mb-16 sm:mb-24"
        >
          <h1 className="text-3xl sm:text-4xl md:text-5xl mb-4" style={{ fontFamily: 'EB Garamond, serif', color: '#f0ebe0' }}>
            Episodes
          </h1>
          <p className="text-base sm:text-lg opacity-50" style={{ fontFamily: 'EB Garamond, serif', color: '#f0ebe0' }}>
            A conversation space at the intersection of cinema and culture.
          </p>
        </motion.div>

        {/* Episodes */}
        <div className="space-y-12">
          {episodes.map((ep, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.2 + i * 0.1 }}
              data-testid={`episode-${ep.number}`}
            >
              {/* Thumbnails */}
              <div className={`grid gap-3 sm:gap-4 mb-8 ${ep.thumbnails.length > 1 ? 'grid-cols-2' : 'grid-cols-1'}`}>
                {ep.thumbnails.map((thumb, j) => (
                  <a key={j} href={thumb.url} target="_blank" rel="noopener noreferrer" className="relative overflow-hidden rounded-lg group">
                    <img
                      src={thumb.src}
                      alt={thumb.partLabel || thumb.partNum}
                      className="w-full aspect-video object-cover opacity-80 group-hover:opacity-100 group-hover:scale-[1.02] transition-all duration-500"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />
                    <div className="absolute bottom-0 left-0 right-0 p-3 sm:p-5">
                      {thumb.partNum && (
                        <div className="font-mono text-[10px] sm:text-[10px] tracking-[0.18em] uppercase opacity-80 mb-1" style={{ color: '#f0ebe0' }}>
                          {thumb.partNum}
                        </div>
                      )}
                      {thumb.partLabel && (
                        <div className="text-base sm:text-lg leading-tight" style={{ fontFamily: 'EB Garamond, serif', color: '#e8c47a' }}>
                          {thumb.partLabel}
                        </div>
                      )}
                    </div>
                  </a>
                ))}
              </div>

              {/* Title */}
              <div className="mb-6">
                <div className="font-mono text-[11px] sm:text-xs tracking-[0.15em] sm:tracking-[0.2em] uppercase opacity-75 mb-3" style={{ color: '#f0ebe0' }}>
                  Episode {ep.number} &middot; {ep.role}
                </div>
                <h2 className="text-2xl sm:text-2xl md:text-3xl mb-3 leading-tight" style={{ fontFamily: 'EB Garamond, serif', color: '#f0ebe0' }}>
                  {ep.title}
                </h2>
                <p className="text-base sm:text-base opacity-80 leading-relaxed" style={{ fontFamily: 'EB Garamond, serif', color: '#f0ebe0' }}>
                  {ep.subtitle}
                </p>
              </div>

              {/* Read the essay */}
              <Link
                to={ep.researchLink}
                className="inline-block py-4 sm:py-4 px-7 sm:px-8 rounded border transition-all duration-300 hover:bg-[#f0ebe0]/[0.04]"
                style={{ borderColor: 'rgba(240,235,224,0.2)', color: '#f0ebe0' }}
                data-testid={`episode-${ep.number}-read`}
              >
                <div className="font-mono text-[10px] sm:text-[10px] tracking-[0.15em] uppercase opacity-70 mb-1">Read</div>
                <div className="text-lg sm:text-lg" style={{ fontFamily: 'EB Garamond, serif' }}>Behind the Episode</div>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Conversations;
